import { FaTimes } from "react-icons/fa";
const CustomPopup = ({ open, sampleCsv, closeSampleCsvDialog }) => {
  return (
    <div>
      {open && (
        <div className="popup-container">
          <div className="popup-container-innner">
            <div className="d-flex justify-content-between w-100 brderbtm pad-bottom-10">
              <h6 className="fs-20 semi-bold black"> Sample CSV File</h6>
              <FaTimes
                className="crossview cp"
                onClick={() => closeSampleCsvDialog()}
              />
            </div>
            <div className="oflow">
              <img src={sampleCsv} className="sample-csv-img" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomPopup;
